export const DB_NAME = "ArtifactsDB";
export const DB_VERSION = 1;
export const STORE_NAME = "artifacts";
